import { useState, useEffect } from "react";
import CustomButton from "../../../Components/Buttons/Custom";
import DemoModal from "../../Purchase/Components/DemoModal";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";

export default function Buttons({setModalClosed}) {
  const navigate = useNavigate();
  const { search } = useLocation();
  const nextParam = new URLSearchParams(search).get("next");
  const shouldOpenDemo = nextParam === "demo";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openedFromNext, setOpenedFromNext] = useState(false);
  const [accountData, setAccountData] = useState(null);
  const fetchAccountData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}landing/challenges/demo/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try to refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}auth/trader/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → log out and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            navigate("/signin");
            return; // ⬅️ IMPORTANT: stop here
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new access token
          response = await fetch(
            `${API_BASE_URL}landing/challenges/demo/`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("access")}`,
              },
            },
          );
        } catch (err) {
          console.error("Error refreshing token:", err);
          return;
        }
      }

      // handle final response (original or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAccountData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  useEffect(() => {
    fetchAccountData();
  }, []);

  useEffect(() => {
    if (shouldOpenDemo && !openedFromNext) {
      setIsModalOpen(true);
      setOpenedFromNext(true);
    }
  }, [shouldOpenDemo, openedFromNext]);
  return (
    <div className="w-full flex gap-2.5 items-center justify-end">
      <CustomButton
        onClick={() => {
          setIsModalOpen(true);
        }}
        text="شروع چالش تمرینی"
        className="w-full max-w-44 border border-zi-border-dark bg-transparent text-zi-text-light dark:text-zi-text-dark hocus:ring-inset hocus:ring-1 hocus:ring-zi-border-dark"
      />

      <CustomButton
        text="شروع چالش جدید"
        className="w-full max-w-44 bg-zi-buttonbg-primary text-zi-text-dark hocus:opacity-85"
        textShadow={true}
        onClick={() => navigate("/purchase")}
      />

      {isModalOpen && (
        <div
          className="w-full h-full min-h-0 fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="w-11/12 max-w-sm max-h-full"
            onClick={(e) => e.stopPropagation()}
          >
            <DemoModal
              setModalClosed={setModalClosed}
              onClose={() => setIsModalOpen(false)}
              accountData={accountData}
            />
          </div>
        </div>
      )}
    </div>
  );
}
